module.exports = __webpack_public_path__ + "img/molecule_video_splash.bcd68d15.jpg";